import MerchantSlider from './MerchantSlider'

export default MerchantSlider
